import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <Section background="navy" data-id="element-65">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-66">
        {/* For You */}
        <div data-id="element-67">
          <h3 className="text-2xl font-serif text-[#d4a574] mb-8 border-b border-[#d4a574]/30 pb-4" data-id="element-68">
            Es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-69">
            {['eres mujer 35+', 'vives en modo responsabilidad', 'te cuesta dormir por pensamientos, pendientes, o miedo al mañana', 'quieres algo práctico, corto y repetible'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-70">
                <Check className="text-[#d4a574] flex-shrink-0 mt-1" size={20} data-id="element-71" />
                <span className="text-slate-200" data-id="element-72">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div data-id="element-73">
          <h3 className="text-2xl font-serif text-slate-400 mb-8 border-b border-slate-700 pb-4" data-id="element-74">
            No es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-75">
            {['buscas una cura instantánea sin hacer nada', 'tu insomnio es severo y necesitas atención clínica (esto no lo reemplaza)', 'no estás dispuesta a escribir 5 minutos'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-76">
                <X className="text-slate-500 flex-shrink-0 mt-1" size={20} data-id="element-77" />
                <span className="text-slate-400" data-id="element-78">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}